import axios from 'axios';

//const API_URL = process.env.REACT_APP_API_URL || 'https://senoscar.site/api';
//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8081/api';
 const API_URL = process.env.REACT_APP_API_URL || 'https://apps.prod.atlanticds-sn.com/senoscar/api';


const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Fonction pour vérifier si c'est une erreur d'expiration de token
const isTokenExpiredError = (error) => {
    if (!error.response) return false;

    const status = error.response.status;
    const data = error.response.data || {};
    const message = (data.message || '').toLowerCase();
    const errorString = JSON.stringify(data).toLowerCase();

    // Vérifier le statut et le contenu de l'erreur
    const isAuthError = status === 401 || status === 403;
    const hasExpiredKeywords = message.includes('expired') ||
        message.includes('expire') ||
        message.includes('jwt expired') ||
        errorString.includes('expired') ||
        errorString.includes('jwt expired');

    return isAuthError && (hasExpiredKeywords || status === 403);
};

// Fonction pour gérer la déconnexion avec message
const handleLogout = (message = 'Votre session a expiré. Veuillez vous reconnecter.') => {
    console.log('Déconnexion automatique:', message);

    // Nettoyer le localStorage (adaptez selon vos clés)
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('authToken');

    // Stocker le message d'erreur pour l'afficher sur la page de login
    localStorage.setItem('sessionMessage', message);

    // Rediriger vers la page de login
    //window.location.href = '/login';
    window.location.href = '/login';
};

// Add a request interceptor to add the auth token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle auth errors
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.log('Erreur interceptée:', error.response?.status, error.response?.data);

        // Gérer les erreurs d'authentification (401, 403)
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            if (isTokenExpiredError(error)) {
                handleLogout('Votre session a expiré. Veuillez vous reconnecter.');
            } else {
                handleLogout('Accès non autorisé. Veuillez vous reconnecter.');
            }
        }

        return Promise.reject(error);
    }
);

export default api;